import React from 'react';
import { Download } from '@mui/icons-material';
import { Fab } from '@mui/material';
import { usePDF, Margin } from 'react-to-pdf';
import SimplePosition from '../../teal-react/components/atoms/SimplePosition';

const PdfWrapper = ({
  children,
  filename,
}: {
  children: any;
  filename?: string;
}) => {
  const { toPDF, targetRef } = usePDF({
    filename,
    page: {
      margin: Margin.MEDIUM,
    },
  });

  return (
    <div style={{ width: 792 }}>
      {filename ? (
        <SimplePosition position="top right" paddingY={10} paddingX={10}>
          <Fab
            title={`Download ${filename}`}
            size="small"
            color="primary"
            aria-label="download"
            onClick={() => toPDF()}
          >
            <Download />
          </Fab>
        </SimplePosition>
      ) : null}
      <span ref={targetRef} className={'plusco-pdf'}>
        {children}
      </span>
    </div>
  );
};

export default PdfWrapper;
